import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import Search from '@ifeng-fe/ui_pc_search';

/**
 * for this page
 */

class SearchNav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        defaultLogo: 'http://y0.ifengimg.com/a/2015/0928/ifeng.jpg',
    };

    render() {
        const { content } = this.props;
        const { search, surveyinfo } = content;
        const { defaultLogo } = this.state;

        // console.log(content);

        return (
            <div className={styles.searchNav}>
                <div className={styles.logoWrapper}>
                    <a href={surveyinfo.channelurl} target="_blank" className={styles.logo}>
                        <img
                            src={surveyinfo.channellogourl.indexOf('test') ? defaultLogo : surveyinfo.channellogourl}
                            alt={surveyinfo.channelname}
                        />
                    </a>
                    <div className={styles.breadCrumb}>
                        <a
                            href={
                                surveyinfo.channelurl && surveyinfo.channelurl.replace('http://', 'https://')
                            }>{`凤凰网${surveyinfo.channelname}`}</a>{' '}
                        &gt; 调查
                    </div>
                </div>
                <div className={styles.search}>
                    <Chip id="10129" type="static" title="通用搜索" groupName="头部" content={search}>
                        <Search />
                    </Chip>
                </div>
            </div>
        );
    }
}

export default SearchNav;
